import { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

import { useActionData, useSubmit } from 'react-router';

import Button from 'client/components/aria/Button/Button';

import geometry from 'client/utils/format/ol/geometry';
import { jsonToFormData } from 'client/utils/helpers/Enquiry/Enquiry';
import { CREATE_ENQUIRY_PAGE } from 'client/utils/routes/routeConstants';

const ContinueEnquiryButton = () => {
    const source = useSelector(state => state?.aoi?.source);
    const draftEnquiryFromStore = useSelector(state => state?.enquiries?.draftEnquiry.payload);
    const { enquiry } = useActionData() || {};
    const [draftEnquiry, setDraftEnquiry] = useState(() => {
        if (enquiry) {
            return enquiry;
        } else {
            return draftEnquiryFromStore || {};
        }
    });
    const submit = useSubmit();

    const intl = useIntl();

    useEffect(() => {
        if (source) {
            updateGeometry(source);
        }
    }, []);

    const updateGeometry = (source) => {
        const features = source?.getFeatures();
        if (draftEnquiry && features && features.length > 0) {
            const aoi = features[0];
            const aoiGeometry = aoi?.getGeometry();
            const geoJsonGeometry = geometry?.toGeoJSON(aoiGeometry, 64, true);
            setDraftEnquiry(prevState => {
                return {
                    ...prevState,
                    geometry: geoJsonGeometry
                };
            });
        }
    };

    const handleOnPress = () => {
        const formData = jsonToFormData(draftEnquiry);
        submit(formData, {
            action: CREATE_ENQUIRY_PAGE,
            method: 'PUT'
        });
    };

    return <Button data-testid="mapToolBar.enquiry.continue"
        variant="success"
        onPress={handleOnPress}>
        { intl.formatMessage({ id: 'continueEnquiryButton.text' }) }
    </Button>;
};

export default ContinueEnquiryButton;
